import type { useMatches } from 'react-router-dom';
import type { TRouteLoaderData } from '../../types/commonTypes';

/**
 * Browser tab title from nested route loader `title` values (deepest first),
 * falling back through optional crumbs to "Screenrights".
 */
export const documentTitleFromMatches = (
  matches: ReturnType<typeof useMatches>,
  ...extraCrumbs: Array<string | undefined>
): string =>
  [
    ...matches
      .map((match) => (match.data as TRouteLoaderData | undefined)?.title)
      .reverse(),
    ...extraCrumbs,
    'Screenrights',
  ]
    .filter((title): title is string => !!title)
    .join(' | ');
